import axios from 'axios';
const url = `${process.env.REACT_APP_BACKEND_URL}/event`;

export const fetchEvents = async (clubId) =>
    (await axios.get(`${url}/list?clubId=${clubId}`, { withCredentials: true })).data;

export const createEvent = async (clubId, title, eventDate) =>
    (await axios.post(`${url}/create`,
        { clubId, title, eventDate },
        { withCredentials: true })).data;